<template>
  <section id="map" class="section -centered -map">
    <div class="section__content">
      <h2 class="section__legend">{{ legend }}</h2>
      <h3 class="section__title">{{ title }}</h3>
    </div>

    <GoogleMapFilters
      v-if="mapsApiContext"
      :maps-api-context="mapsApiContext"
      :pseudo-products="pseudoProducts"
      @place-changed="setPlace"
    />

    <div class="section__map">
      <GoogleMapViewport
        v-if="mapsApiContext"
        :maps-api-context="mapsApiContext"
        :locations="displayLocations"
        :place="place"
      />
    </div>
  </section>
</template>

<script>
import GoogleMapFilters from '@/components/googleMap/GoogleMapFilters.vue'
import GoogleMapViewport from '@/components/googleMap/GoogleMapViewport.vue'
import { getDistance } from '@/components/googleMap/map-helper.js'

const soilManagement = 'soil-management'

export default {
  name: 'LocationMap',
  components: { GoogleMapFilters, GoogleMapViewport },
  props: {
    legend: { type: String, default: null },
    title: { type: String, default: null },
  },
  data() {
    return {
      place: null,
      mapsApiContext: null,
    }
  },
  computed: {
    pseudoProducts() {
      return {
        [soilManagement]: this.$t('soil_management'),
      }
    },
    filteredLocations() {
      let locations = this.$store.getters.locations

      if (this.$route.query.businessUnit) {
        if (this.$route.query.businessUnit === 'office') {
          locations = locations.filter((location) => location.office)
        } else {
          const id = this.$store.getters.business_units.find(
            ({ slug }) => slug === this.$route.query.businessUnit,
          )?.id
          if (id) {
            locations = locations.filter(({ business_unit_id }) => business_unit_id === id)
          }
        }
      }

      if (this.$route.query.productType) {
        const id = this.$store.getters.products.find(
          ({ slug }) => slug === this.$route.query.productType,
        )?.id
        if (id) {
          locations = locations.filter(({ products }) => products.includes(id))
        }
      }

      return locations
    },
    displayLocations() {
      if (!this.place) return this.filteredLocations
      return [...this.filteredLocations]
        .toSorted((p1, p2) => getDistance(p1, this.place) - getDistance(p2, this.place))
        .slice(0, 10)
    },
  },

  methods: {
    setPlace(place) {
      this.place = place
    },
    setUpMapsApiContext() {
      if (this.mapsApiContext) return
      if (window.google && window.google.maps) {
        this.mapsApiContext = window.google.maps
        return
      }
      this.loadGoogleApi()
    },
    loadGoogleApi() {
      const googleMapsScript = document.createElement('script')
      googleMapsScript.src = `https://maps.googleapis.com/maps/api/js?key=${import.meta.env.VITE_APP_GOOGLE_MAP_KEY}&libraries=places,marker&callback=googleMapsLoaded&loading=async`
      googleMapsScript.async = true
      googleMapsScript.defer = true

      window.googleMapsLoaded = () => {
        if (window.google && window.google.maps) {
          this.mapsApiContext = window.google.maps
        }
        delete window.googleMapsLoaded
      }

      document.head.appendChild(googleMapsScript)
    },
  },
  beforeMount() {
    this.setUpMapsApiContext()
    this.$store.dispatch('loadBusinessUnits')
    this.$store.dispatch('loadProducts')
    this.$store.dispatch('loadLocations')
  },
}
</script>
